<con-app profileLink="/account/me" accountLabel="Connect Administration" [sideNavCollection]="links" [logoImage]="''" [appName]="'Unified Engineering Management'">
  <router-outlet></router-outlet>
</con-app>
